import styled from 'styled-components';

export const TabDirtyDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #854ee0;
  margin-left: 6px;
  vertical-align: middle;
`;

export const MoneyInputWrapper = styled.div`
  input {
    text-align: right;
  }
`;

export const CoverageRow = styled.div<{ $disabled?: boolean }>`
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;
  background: ${({ $disabled }) => ($disabled ? '#fafafa' : '#fff')};
  opacity: ${({ $disabled }) => ($disabled ? 0.7 : 1)};
`;

export const CancellationBanner = styled.div`
  background: #fff6f6;
  border: 1px solid #e0b4b4;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 16px;
  color: #9f3a38;
`;

export const DiffList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
    font-size: 14px;

    &:last-child {
      border-bottom: none;
    }
  }
`;

export const DiffOld = styled.span`
  color: #9f3a38;
  text-decoration: line-through;
  margin-right: 8px;
`;

export const DiffNew = styled.span`
  color: #2c662d;
  font-weight: 600;
`;

export const DiffLabel = styled.strong`
  display: block;
  margin-bottom: 2px;
  color: #333;
`;
